export const getProfileHref = (
    baseUrl: string,
    searchParams: URLSearchParams | Map<string, string | null>
) => {
    if (!searchParams) return baseUrl

    const queryString =
        searchParams instanceof URLSearchParams ? searchParams.toString() : String(searchParams)

    if (!queryString) return baseUrl

    const delimiter = baseUrl.includes("?") ? "&" : "?"
    return `${baseUrl}${delimiter}${queryString}`
}
